'use client'

import { useEffect, useRef, useState } from 'react'

export default function InteractiveLogo() {
	const logoRef = useRef(null)
	const [windowHeight, setWindowHeight] = useState(0)

	useEffect(() => {
		if (!logoRef?.current) return

		function mouseMoveHandler(event) {
			const yPos = event.clientY
			let yPercent = yPos / windowHeight
			let fontWeight = 996 - Math.floor((996 - 450) * yPercent)
			logoRef.current.style.fontVariationSettings = `'wght' ${fontWeight}`
		}
		mouseMoveHandler({ pageY: window.innerHeight / 2 })

		function resizeHandler() {
			setWindowHeight(window.innerHeight)
		}
		setWindowHeight(window.innerHeight)

		window.addEventListener('mousemove', mouseMoveHandler, false)
		window.addEventListener('resize', resizeHandler, false)

		return () => {
			window.removeEventListener('mousemove', mouseMoveHandler, false)
			window.removeEventListener('resize', resizeHandler, false)
		}
	}, [logoRef.current])

	return (
		<div
			ref={logoRef}
			className="text-[10.1vw] md:text-[10.25vw] xl:text-[10.42vw] font-drama leading-[0.72] whitespace-nowrap text-center mobile:[font-variation-settings:'wght'_996!important]"
		>
			<span className="inline-block ml-[-0.03em]">D</span>
			<span className="inline-block ml-[-0.05em]">R</span>
			<span className="inline-block ml-[-0.085em]">A</span>
			<span className="inline-block ml-[0.025em]">M</span>
			<span className="inline-block ml-[0.02em]">A</span>
		</div>
	)
}
